import { ReactComponent as DeleteAdminSvg } from "../../assets/images/svgs/deleteAdmin.svg";

const DeleteAdminIcon = ({ className = "", ...props }) => {
  return (
    <DeleteAdminSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default DeleteAdminIcon;
